import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

interface DashboardStatsResponse {
  success: boolean;
  data: {
    totalUsers: number;
    activeDrones: number;
    openTickets: number;
    activeOrganizations: number;
  };
}

/**
 * Admin Dashboard Component
 * Main landing page for admin portal showing key metrics and quick actions.
 * Fetches live stats from GET /admin/dashboard/stats on init.
 */
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  statsLoading = true;
  totalUsers = '--';
  activeDrones = '--';
  openTickets = '--';
  activeOrganizations = '--';

  constructor(private http: HttpClient) {}

  async ngOnInit(): Promise<void> {
    try {
      const response = await firstValueFrom(
        this.http.get<DashboardStatsResponse>(
          `${environment.apiUrl}/admin/dashboard/stats`
        )
      );

      if (response.success && response.data) {
        this.totalUsers = String(response.data.totalUsers);
        this.activeDrones = String(response.data.activeDrones);
        this.openTickets = String(response.data.openTickets);
        this.activeOrganizations = String(response.data.activeOrganizations);
      }
    } catch (error) {
      console.error('Failed to load dashboard stats:', error);
      // Graceful degradation: leave values as '--'
    } finally {
      this.statsLoading = false;
    }
  }
}
